module.exports = __webpack_public_path__ + "img/adModel5.abeae53d.png";